import SettingsContent from "@/components/SettingsContent";

export default function Settings() {
  return (
    <div className="px-6 py-10 md:max-w-2xl md:mx-auto md:py-14 animate-in fade-in slide-in-from-bottom-4 duration-700">
      <SettingsContent />
    </div>
  );
}
